import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGoogleLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 21,
	height: 20,
	viewBox: "0 0 21 20",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_2567_2126)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M20.0746 10.225C20.0746 9.40005 20.0121 8.80005 19.8623 8.17505H10.4871V11.8875H15.9924C15.88 12.8125 15.2808 14.2 13.945 15.1375L13.9326 15.2625L16.8912 17.5625L17.0909 17.5875C18.9885 15.8375 20.0746 13.2625 20.0746 10.225Z",
				fill: "#2970FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.4871 20.0001C13.1836 20.0001 15.4431 19.1126 17.1035 17.5751L13.9576 15.1251C13.1087 15.7126 11.9852 16.1251 10.4996 16.1251C7.85304 16.1251 5.61845 14.3751 4.8195 11.9751L4.70714 11.9876L1.61118 14.3751L1.57373 14.4876C3.2091 17.7501 6.5797 20.0001 10.4871 20.0001Z",
				fill: "#4EA52F"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.80688 11.9749C4.59466 11.3499 4.46982 10.6874 4.46982 9.9999C4.46982 9.3124 4.59466 8.6499 4.7944 8.0249V7.8874L1.67347 5.4624L1.5736 5.5124C0.886995 6.8624 0.5 8.3874 0.5 9.9999C0.5 11.6124 0.886995 13.1374 1.56112 14.4874L4.80688 11.9749Z",
				fill: "#FBBC05"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.4869 3.8625C12.3595 3.8625 13.6328 4.675 14.3444 5.35L17.1657 2.6C15.4304 0.9875 13.1834 0 10.4869 0C6.57949 0 3.20889 2.25 1.56104 5.5125L4.79432 8.025C5.60576 5.6125 7.84034 3.8625 10.4869 3.8625Z",
				fill: "#EB4335"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_2567_2126",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			fill: "white",
			transform: "translate(0.5)"
		})
	}) })]
});
export default SvgGoogleLogo;
